import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as actions from '../../../../../actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

function CustomButton({button, buttonType, clickButton}){
  const buttonClass = classNames(
    'cu-ui-button',
    {
      'cu-ui-button-base': buttonType != 'carousel'
    },
    {
      'cu-ui-secondary': buttonType == 'carousel'
    },
    {
      'cu-ui-block': buttonType == 'wide' || buttonType == 'carousel'
    }
  );
  return (
    <button className={buttonClass} onClick={() => {clickButton(button)}}>{button.text}</button>
  )
};

CustomButton.propTypes = {
  button: PropTypes.object,
  buttonType: PropTypes.string,
  clickButton: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {
  return {
    clickButton: bindActionCreators(actions.clickOnButton, dispatch)
  };
};

export default connect(undefined, mapDispatchToProps)(CustomButton);



// WEBPACK FOOTER //
// ./src/components/chat-body/chat-cells/button-cell/custom-button/index.jsx